import { SHOW_BOOKING_FAILURE } from "./types";

const showBookingFailure = (reason) => ({
  type: SHOW_BOOKING_FAILURE,
  reason,
});

export default showBookingFailure;
